<template>
  <div class="box">
    <carousel
      :per-page="1"
      :paginationPadding="4"
      :paginationActiveColor="'#7F1084'"
      :navigationEnabled="true"
      :navigationClickTargetSize="1"
      :navigationNextLabel="navigationNextLabel"
      :navigationPrevLabel="navigationPrevLabel"
    >
      <slide
        v-for="(photo, index) in photos"
        :key="'photo-' + index"
        @slideclick="openModal(photo)"
      >
        <figure class="image is-16by9">
          <img v-bind:src="photo.image.url">
        </figure>
        <nav class="level">
          <div class="level-item has-text-centered">
            <p class="subtitle is-size-6">
              {{ $prismic.richTextAsPlain(photo.caption) }}
            </p>
          </div>
        </nav>
      </slide>
    </carousel>
    <b-modal
      :active.sync="modalState"
      :onCancel="() => this.modalState = false"
    >
      <p class="image is-16by9">
        <img v-bind:src="modalUrl">
      </p>
    </b-modal>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'HomeCarousel',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      photos: [],
      navigationNextLabel: '<a class="button is-light is-inverted"><span class="icon"><i class="fas fa-angle-right"></i></span></a>',
      navigationPrevLabel: '<a class="button is-light is-inverted"><span class="icon"><i class="fas fa-angle-left"></i></span></a>',
      modalState: false,
      modalUrl: '',
    };
  },
  methods: {
    getContent() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'home-carousel'),
      ).then((response) => {
        this.photos = response.results[0].data.carousel_images;
      });
    },
    openModal(photo) {
      this.modalUrl = photo.image.url;
      this.modalState = true;
    },
  },
  created() {
    this.getContent();
  },
};

</script>

<style lang="scss" scoped>
.level {
  margin-top: 0.5em;
}

</style>
